//Footer.js

const Footer = ({ user }) =>{
    return(
    <footer>
        <p  className="wrapper">&copy; Ana Rodrigues 2026 | contact@garagelab.ca</p>
       </footer>
    )
}
export default Footer;